export default __webpack_public_path__ + "static/media/SR.2f17465a.svg";